module.exports = __webpack_public_path__ + "img/tutorial-12.b49b2d07.svg";